import React from "react";
import "./NavBar.css";
import Navbar from "react-bootstrap/Navbar";



const NavBar = () => {
  return (
    <Navbar variant="light">
      <Navbar.Brand href="#home">
        <h1 className="d-inline-block align-top logo">CODIUM</h1>
      </Navbar.Brand>
    </Navbar>
  );
};

export default NavBar;
